import React, { FC, useMemo } from "react";
import { Typography, styled } from "@mui/material";
import Badge from "assets/image/badge.webp";
import { isDarkMode } from "utills";
import { Maybe } from "api";


const StrickComplete: FC<{ data: Maybe<string> | undefined }> = ({ data }) => {

  const popupData = JSON.parse(data as string);
  const renderText = useMemo(() => {
    const changevalue = "Power User";
    const re = new RegExp(changevalue);
    return popupData?.text1.split(re).flatMap((x, key, arr) => {
      if (key + 1 === arr.length)
        return x
      return [x, <PowerUser key={key}>{changevalue}</PowerUser>]
    })
  }, [popupData?.text1])

  return (
    <>
      <Container>
        <Image src={Badge} />
        <Title>
          {popupData?.title}
        </Title>
        <Subtitle>
          {renderText}
        </Subtitle>
      </Container>
    </>
  );
};

export default StrickComplete;

const Container = styled('div')(({ theme }) => ({
  maxWidth: '600px',
  width: '100%',
  height: '100%',
  marginTop: 30,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 20,
  zIndex: 99,
  paddingTop: 50,
  position: 'relative',
  overflowX: 'hidden',

  '&::after': {
    content: '""',
    backgroundImage: isDarkMode(theme) ? 'linear-gradient(#e4f1ff,#1c1f26)' : 'linear-gradient(#e4f1ff,#f6fffa)',
    position: 'absolute',
    height: '68%',
    left: '-40%',
    right: '-40%',
    bottom: 0,
    borderTopLeftRadius: '45%',
    borderTopRightRadius: '45%',
    zIndex: -1,
  },
  '@media(min-width: 540px)': {
    padding: 20,
  }
}))

const Title = styled(Typography)({
  fontSize: 24,
  fontWeight: '700',
  lineHeight: '36px',
  marginTop: 40,
  color: '#000',
  textAlign: "center",
  '@media(min-width: 540px)': {
    marginBottom: 24,
  }
})

const PowerUser = styled('span')({
  color:'#2576d8'
})

const Subtitle = styled(Typography)({
  fontSize: 24,
  fontWeight: '700',
  lineHeight: '36px',
  marginBottom: 10,
  // marginTop: 40,
  color: '#000',
  textAlign: "center",
  'span': {
    color: '#1b6ac9'
  },
  '@media(min-width: 540px)': {
    marginBottom: 24,
  }
})


const Image = styled(
  (
    props: React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >
  ) => <img height={80} width={80} {...props} />
)(({ theme }) => ({
  height: 200,
  width: 180,
  marginTop: "25%",
  '@media (min-width: 540px)': {
    marginTop: "10%",
  }
}));
